<template>
  <div class="payContent">
    <div class="paySuccess textAlignCenter" v-if="type == 1">
      <van-image
        :src="paySuccessImg"
        style="width: 3rem; height: 3rem"
      ></van-image>
      <div class="fz18 marginTop6">恭喜你，兑换成功</div>
    </div>
    <div class="payFail textAlignCenter" v-if="type == 2">
      <van-image
        :src="payFailImg"
        style="width: 3rem; height: 3rem"
      ></van-image>
      <div class="fz18">兑换失败</div>
    </div>
    <div class="textAlignCenter marginTop20">
      <router-link to="/myExchange" v-if="type && type == 1">
        <van-button
          type="default"
          round
          class="marinTop10"
          style="margin: 0 10px"
          >查看兑换记录</van-button
        >
      </router-link>
      <router-link to="/pointsList" v-if="type">
        <van-button
          type="primary"
          round
          class="marinTop10"
          style="margin: 0 10px"
          >返回积分商城</van-button
        >
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: "",
      consumeMoney: "",
      consumeName: "",
      paySuccessImg: require("../../assets/images/integralSuccess.png"),
      payFailImg: require("../../assets/images/integralFail.png"),
    };
  },
  created() {
    let { isSuccess } = this.$route.query;
    this.type = isSuccess;
  },
};
</script>

<style lang='less'>
.payContent {
  margin-top: 40%;
  color: #000;
  .tc {
    display: block;
    margin: 0 auto;
    text-align: center;
    margin-top: 15px;
    & > span {
      background: #f2f2f2;
      color: #000;
      padding: 10px 20px;
      text-align: center;
      border-radius: 15px;
    }
  }
}
</style>